import MyClientsList from "./MyClientsList";

export default MyClientsList;
